export default "__VITE_ASSET__BWytHRmG__"